import { useState } from "react";
import { useQuery } from "react-query";

// components
import Modal from "components/LoginAndRegister/Modal";
import RenderHTML from "components/RenderHTML";
import { ListingAboutPopup } from "components/ListingNew/ListingAboutPopup";

// helpers
import getCancellationPolicyContent from "helpers/getCancellationPolicyContent";

// style
import "global/style.scss";
import "./style.scss";
import { useTheme } from "components/ListingNew/ListingTheme";

const list = [
	"House Rules",
	"Cancellation Policy",
	"Things you need to know",
	"Things to do",
];

const ListingAbout = ({ content, color }) => {
	const [active, setActive] = useState("");

	const { data, isLoading } = useQuery({ queryKey: ["listing"] });

	// @ts-ignore
	const listingList = data?.data?.data?.listing_list;
	const isNext = false;
	const locality = data?.data?.data?.sleeping_and_spotlist?.spot_info?.locality;
	const aboutHome =
		data?.data?.data?.sleeping_and_spotlist?.spot_info?.about_home;
	const cancellationPolicy = listingList.cancellation;
	const checkInTime = listingList.in_time + listingList.in_time_format;
	const checkOutTime = listingList.out_time + listingList.out_time_format;
	const houseRules =
		data?.data?.data?.sleeping_and_spotlist?.spot_info?.house_rules +
		`<ul><li>Security Deposit: ₹ ${listingList?.security_deposit} per ${
			listingList?.TYPE_FLAG === "MV" ? "villa" : "room"
		}</li></ul></li></ul>`;
	let spotInfo =
		data?.data?.data?.sleeping_and_spotlist?.spot_info?.about_booking;

	if (listingList?.TYPE_FLAG === "EV") {
		spotInfo = spotInfo?.replace(
			"</ul>",
			`<li>We only sell this home with <b>all the ${listingList?.num_similar_rooms} rooms</b>, if you wish to book fewer rooms, you may call <a href='tel:08069160000'>08069160000</a> to check if it’s possible</li></ul>`,
		);
	}

	const theme = useTheme();

	return (
		<>
			<div
				className="about__content__container"
				style={{
					marginLeft: "17px",
					color: theme?.secondaryTextColor,
				}}
			>
				{content}
			</div>
			<div className="listing__main__btn__container">
				{list.map((v, i) => {
					return (
						<button
							style={theme.borderBtn}
							className="listing__main__btn"
							key={i}
							onClick={() => setActive(v)}
						>
							{v}
						</button>
					);
				})}
			</div>

			<Modal shouldShow={active !== ""} onRequestClose={() => setActive("")}>
				<ListingAboutPopup
					heading={active}
					close={() => setActive("")}
					content={
						active === "House Rules" ? (
							<>
								<div className="rule-1">
									<div className="clr-black">
										<p style={{ fontSize: "14px" }}>
											Check-in after :{" "}
											<span
												className="text-sm-bold light"
												style={{ fontSize: "14px" }}
											>
												{checkInTime}
											</span>
										</p>
									</div>
									<div className="clr-black">
										<p
											style={{
												fontSize: "14px",
												marginTop: "8px",
												marginBottom: "16px",
											}}
										>
											Check-out before :{" "}
											<span
												className="text-sm-bold light"
												style={{ fontSize: "14px" }}
											>
												{checkOutTime}
											</span>
										</p>
									</div>
								</div>
								<RenderHTML>{houseRules}</RenderHTML>
							</>
						) : active === "Cancellation Policy" ? (
							<>
								<div className="text-sm-light light">
									{getCancellationPolicyContent(cancellationPolicy).map(
										(item, index) => {
											return (
												<ul key={index} style={{ fontSize: "14px" }}>
													<li>{item}</li>
												</ul>
											);
										},
									)}
								</div>
							</>
						) : active === "Things you need to know" ? (
							<RenderHTML>{spotInfo}</RenderHTML>
						) : active === "Things to do" ? (
							<RenderHTML>{locality}</RenderHTML>
						) : (
							""
						)
					}
				/>
			</Modal>
		</>
	);
};

export default ListingAbout;
